var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassEyeActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 23,
    viewBox: "0 0 37 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke:#707070;}.a{stroke-linejoin:round;}.b{stroke-miterlimit:10;}"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-102.273 -499)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 18,
    cy: 11,
    rx: 18,
    ry: 11,
    transform: "translate(102.773 499.5)",
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(114.773 504.5)",
    style: {
      fillRule: "evenodd",
      stroke: "#707070",
      fill: "rgb(249, 249, 249)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassEyeActive);
export default __webpack_public_path__ + "static/media/passEyeActive.d068bbbc65d6471c63bdf591403c2224.svg";
export { ForwardRef as ReactComponent };